module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image9_4-f9fc5aea3a2a01ad94692949b4ace68c.png";